interface Props {
  validationTargetRef?: React.Ref<HTMLDivElement>;
  visibility: any;
  fieldname: string;
  className?: string;
  children?: React.ReactNode;
}

export default function FindingFormVisibilityWrapper(props: Props) {
  const visible =
    !props.visibility ||
    !(props.fieldname in props.visibility) ||
    Boolean(props.visibility[props.fieldname]);

  if (!visible) {
    return <></>;
  }

  return <div className={props.className} ref={props.validationTargetRef}>{props.children}</div>;
}
